import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  cityActiveInactive,
  createCity,
  deleteCity,
  findAllActiveCity,
  getAllCities,
  getCityById,
  updateCity,
} from "./services/city.services";
import { ICity, ICityInitialState } from "./cityModel";

const initialState: ICityInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  CityList: [],
  CityID: null,
  CityDetail: {
    state_id: null,
    country_id: null,
    city_name: "",
    isactive: 1,
  },
};

const citySlice = createSlice({
  name: "city",
  initialState,
  reducers: {
    clearCityDetails: (state) => {
      state.CityDetail = initialState.CityDetail;
    },
    setCityID: (state, action) => {
      state.CityID = action.payload;
    },
    clearCityID: (state) => {
      state.CityID = initialState.CityID;
    },
  },
  extraReducers: (builder) => {
    /* For getAll Cities */
    builder.addCase(getAllCities.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllCities.fulfilled,
      (state, action: PayloadAction<ICity[]>) => {
        state.loading = false;
        state.CityList = action.payload || [];
      }
    );
    builder.addCase(getAllCities.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.CityList = [];
    });

    /* For getCityBy ID */
    builder.addCase(getCityById.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getCityById.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.CityDetail = action.payload;
    });
    builder.addCase(getCityById.rejected, (state, action) => {
      state.formLoading = false;
      state.CityDetail = initialState.CityDetail;
      state.error = action.error.message || "Something went wrong";
    });

    /* For create City */
    builder.addCase(createCity.pending, (state) => {
      state.formLoading = false;
      state.error = "";
    });
    builder.addCase(createCity.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createCity.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });

    /* For Update City */
    builder.addCase(updateCity.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateCity.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateCity.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });

    /* For Delete Cities */
    builder.addCase(deleteCity.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteCity.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteCity.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    /* For cityActiveInactive */
    builder.addCase(cityActiveInactive.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(cityActiveInactive.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(cityActiveInactive.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    /* For FindAllActiveStates */
    builder.addCase(findAllActiveCity.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      findAllActiveCity.fulfilled,
      (state, action: PayloadAction<ICity[]>) => {
        state.loading = false;
        state.CityList = action.payload || [];
      }
    );
    builder.addCase(findAllActiveCity.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.CityList = [];
    });
  },
});

export const { clearCityID, clearCityDetails, setCityID } = citySlice.actions;
export default citySlice.reducer;
